module.exports = __webpack_public_path__ + "img/footer_logo.67b2832d.png";